import { styled } from "@linaria/react";
export type ImageRequireType = {
  src: string;
  srcSet?: string;
  width?: number | string;
  height?: number | string;
  format: "webp" | "jpeg" | "png" | "gif";
  toString(): string;
};
const Img = /*#__PURE__*/styled("img")({
  name: "Img",
  class: "i59q031"
});

function FiberImage(props: {
  alt: string;
  className?: string;
} & Omit<ImageRequireType, "toString" | "format">): JSX.Element {
  return <picture className={props.className}>
      <Img src={props.src} srcSet={props.srcSet} alt={props.alt} width={props.width} height={props.height} decoding="async" loading="lazy" />
    </picture>;
}

export default FiberImage;

require("../../../.linaria-cache/src/components/image/index.linaria.module.css");